import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-aufgaben';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenChecklisteAufgabenEffects {

    ChecklisteAufgaben$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_AUFGABEN),
        mergeMap((x: ac.GetChecklisteAufgabenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteAufgaben(x.checkliste_id).pipe(
                map((result: any) => {
                    return new ac.GetChecklisteAufgabenErfolgreichAction(result, x.checkliste_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteAufgabenFehlerAction(error, x.checkliste_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklistenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklistenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklistenQueryService);
        }
        return this.service;
    }
}
